// extracted by mini-css-extract-plugin
module.exports = {"title":"_9400a595a7--title--unxPS","link":"_9400a595a7--link--GSYcK"};